<template>
  <v-container >
    <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            {{notice}}
          </v-card-title>
  
          <v-card-text>
            {{content}}
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              color="green darken-1"
              text
              @click="dialog=false"
            >
              確定
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-row class="fill-height">
      <v-col
        cols="12"
        class="text--secondary mt-4"
      >
      <p class="mb-0">功能 : 補打卡</p>
      <p class="mb-0">所在群組 : <span class="text-h5" v-bind:style="'color:'+groupColor">{{ groupName }}   </span></p>
      <v-menu
          ref="menud"
          v-model="menu"
          :close-on-content-click="false"
          :return-value.sync="bdate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="bdate"
              label="選擇補打日期"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="bdate"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="menu = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.menud.save(bdate)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      <v-menu
        ref="menu"
        v-model="timePicker"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="btime"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="btime"
            label="選擇補打時間"
            prepend-icon="mdi-clock-time-four-outline"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker
          v-if="timePicker"
          v-model="btime"
          format="24hr"
          full-width
          @click:minute="$refs.menu.save(btime)"
        ></v-time-picker>
      </v-menu>
      <v-text-field
        v-model="reason"
        :rules="[chk_Name]"
        label="原因"
        placeholder="請輸入事由"
      ></v-text-field>
      <!-- <v-select
        v-model="select"
        item-text="name"
        item-value="val"
        :items="selNotice"
        label="提醒方式"
      ></v-select> -->

      <v-btn
          color="primary"
          :disabled="tripDisabled"
          depressed
          style="width: 100%;"
          @click = "api_addPatch"
        >
          <v-icon>mdi-send-outline</v-icon>
          送出申請
        </v-btn>
      </v-col>
    </v-row>          
  </v-container>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  import axios from 'axios';
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    data: () => ({
      dialog:false,
      str_userid:"",
      str_groupid:"",
      UserName:"",
      groupName:"",
      // selNotice:[
      //     {name:'個人提醒',val:1},
      //     {name:'群組提醒',val:2},
      //     {name:'群組+個人提醒',val:3},
      //   ],
      // select:1,
      menu:false,
      tripDisabled:true,
      timePicker:false,
      reason:"",
      btime:"00:00",
      bdate:"2021-05-29",
      notice:"申請成功",
      content:"待依規定主管審核",
    }),
    mounted () {
      this.$store.commit('SET_LAYOUT', "app-layout")
      let query = this.$route.query;
      this.str_userid = query['Userid'];
      this.str_groupid = query['Groupid'];
      try{
        this.UserName = query['UserName'];
      }catch{
        this.UserName = "姓名錯誤";
      }
      this.groupName = query['GroupName'];
      this.$emit("menuShow",false);
      let Today = new Date();
      this.bdate = Today.getFullYear()+"-"+this.addz(Today.getMonth()+1)+"-"+this.addz(Today.getDate());
    },
    methods: {
      addz:function(num){
        return num<10?'0'+num:num;
      },
      chk_Name(value){
        console.log("被檢測",value);
        if(value ==""){
          this.tripDisabled = true;
          return "請輸入事由"
        }
        this.tripDisabled = false;
        return true;
      },
      api_addPatch(){
        let datetime = this.bdate+" "+this.btime+":00";
        axios
        .get(this.baseURL+'/api/Punch/rePunchin?str_GroupId='+ this.str_groupid +'&strUserLineID='+ this.str_userid +'&str_reason='+ this.reason +'&date='+ datetime +'&loc=線上申請')
        .then((response)=>{
          if(response.data !=""){
            this.notice ="申請成功";
            this.content = "待依規定主管審核";
            this.dialog =true;
          }else{
            this.notice ="申請失敗";
            this.content = "未依規定2天內申請";
            this.dialog =true;
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error)
          this.notice ="申請失敗";
          this.content = "不明原因,請聯絡技術人員";
          this.dialog =true;
        });
      }
    },
  } 
  </script>
  <style>
    .text-shadow{
      /* text-shadow: 0.05em 0.05em 0.08em gray */
      text-shadow: -2px -2px white, 1px 1px #333
    }
    .text-blue-shadow{
      text-shadow: 0.05em 0.05em 0.08em #33347F;
    }
    .text-green-shadow{
      text-shadow: 0.05em 0.05em 0.08em #17A86C;
    }
    .position-center{
      position:absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  </style>